import React, {  useContext } from "react";
import { makeStyles} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import SettingsContext from "src/context/SettingsContext";

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "hidden",
    position: "relative",
    height: "100vh",
    
    // minHeight: "calc(100vh - 415px)",
  },

  root: {
    // background:"url('images/lightbackground.png')",
    overflow: "hidden",
    position: "relative",
    height: "100vh", 

    
  },
  root1: {
    backgroundColor: "#fff",
    // overflow: "hidden",
    position: "relative",
    // background: "#f3f5f7", 
    // height: "99.5vh",
  
  },
  MainLayout: {
    height: "calc(100vh - 75px)",
    // height: "100%",
    position: "relative",
    // overflowY: "auto",
  },
  contentContainer1:{
    height: "calc(100vh - 75px)",
    // height: "100%",
    position: "relative",
  }

}));

const MainLayout = ({ children }) => {
  const classes = useStyles();
  const history = useHistory();
  const themeSeeting = useContext(SettingsContext);
  return (
    <div
      className={
        themeSeeting.settings.theme === "DARK"
          ? `${classes.root1}`
          : `${classes.root}`
      }
    >
 <div className={classes.contentContainer1}>

      <div className={classes.MainLayout}>{children}</div>
 </div>
    </div>
  );
};

export default MainLayout;
